import { useHistory } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";
import Button from "../components/common/Button";

const ConversationsListPage = () => {
  const history = useHistory();

  return (
    <div className="flex flex-col">
      <div className="p-4">
        <Typography.BodyMd>
          {t("support_widget.no_messages_found")}
        </Typography.BodyMd>
        <Button
          label={t("support_widget_v2.conversation_page.title")}
          onClick={() => history.push("/conversations/123")}
        />
      </div>
    </div>
  );
};

export default ConversationsListPage;
